<template>
    <article :class="[ 'notification-item', { 'unread': !HasBeenRead } ]" :title="Title">
        <div class="notification-content" @click="$emit('click')">
            <div class="notification-item-header">
                <h5 class="notification-title">{{ truncatedTitle }}</h5>
            </div>
            <p class="notification-description" v-if="hasDescription" v-html="truncatedDescription"></p>
            <div class="item-footer">
                <p class="footer-item date"><i class="fas fa-clock"></i>{{ format_date(CreatedAt) }}</p>
                <p :class="[ 'footer-item severity', Severity.Name.toLowerCase() ]" v-if="hasSeverity">
                    <i :class="Severity.Icon" v-if="hasSeverityIcon"></i>
                    {{ Severity.Name }}
                </p>
            </div>
        </div>
        <button class="dismiss-btn" title="Dismiss" data-name="HasBeenDismissed" @click="$emit('dismiss')">
            <i class="fas fa-times" data-name="HasBeenDismissed"></i>
        </button>
    </article>
</template>

<script>
    import moment from 'moment'

    export default {
        name: "notification-item",
        props: {
            Title: {
                required: true,
                type: String
            },
            Description: {
                required: false,
                type: String
            },
            Url: {
                required: false,
                type: String
            },
            HasBeenRead: {
                required: true,
                type: Boolean
            },
            HasBeenDismissed: {
                required: true,
                type: Boolean
            },
            CreatedAt: {
                required: true,
                type: String
            },
            Severity: {
                required: false
            }
        },
        methods: {
            format_date(value) {
                if (value) {
                    return moment(String(value)).format('YYYY-MM-DD')
                }
            },
        },
        computed: {
            hasDescription() {
                return !!(this.Description && this.Description.length);
            },
            truncatedTitle() {
                return this.Title.length <= 47
                    ? this.Title
                    : `${this.Title.substring(0, 47)}...`;
            },
            hasSeverity() {
                return !!(this.Severity && this.Severity.Name && this.Severity.Name.length);
            },
            hasSeverityIcon() {
                return !!(this.Severity.Icon && this.Severity.Icon.length);
            },
            truncatedDescription() {
                return this.hasDescription && this.Description.length <= 97
                    ? this.Description
                    : `${this.Description.substring(0, 97)}...`;
            }
        }
    }
</script>
